import { Resolve } from "@jsonforms/core";

function resolveRef(ref: string, root: any): any | undefined {
  try {
    return Resolve.schema(root, ref, root);
  } catch {
    return undefined;
  }
}

export function getEnumFromSchema(
  schema: any,
  root: any
): unknown[] | undefined {
  if (!schema || typeof schema !== "object") return undefined;
  if (Array.isArray(schema.enum)) return schema.enum;
  if (typeof schema.$ref === "string" && root) {
    const resolved = resolveRef(schema.$ref, root);
    const fromRef = getEnumFromSchema(resolved, root);
    if (Array.isArray(fromRef)) return fromRef;
  }
  if (Array.isArray(schema.allOf)) {
    for (const item of schema.allOf) {
      if (!item || typeof item !== "object") continue;
      if (typeof item.$ref === "string" && root) {
        const resolved = resolveRef(item.$ref, root);
        const fromRef = getEnumFromSchema(resolved, root);
        if (Array.isArray(fromRef)) return fromRef;
      } else if (Array.isArray(item.enum)) {
        return item.enum;
      }
    }
  }
  return undefined;
}

export function enumOptionsFromSchema(
  schema: any,
  root: any
): { value: unknown; label: string }[] | undefined {
  const values = getEnumFromSchema(schema, root);
  if (!values) return undefined;
  return values.map((v) => ({ value: v, label: String(v) }));
}
